<template>
  <div class="add-box">
    <el-form label-width="120px" class="user-form">
      <el-form-item label="受助人联系电话:">
        <el-input v-model="recInfo.recPhoneNumber" placeholder="受助人联系电话" maxlength="11" class="input-width" />
      </el-form-item>
      <el-form-item label="受助人联系邮箱:">
        <el-input v-model="recInfo.recMailbox" placeholder="受助人联系邮箱" class="input-width" />
      </el-form-item>
      <el-form-item label="受助人微信号:">
        <el-input v-model="recInfo.recWxNumber" placeholder="受助人微信号" class="input-width" />
      </el-form-item>
      <el-form-item label="申请人联系电话:">
        <el-input v-model="recInfo.applicantPhoneNumber" placeholder="申请人联系电话" class="input-width" />
      </el-form-item>
      <el-form-item label="申请人联系邮箱:">
        <el-input v-model="recInfo.applicantMailbox" placeholder="申请人联系邮箱" class="input-width" />
      </el-form-item>
      <el-form-item label="申请人微信号:">
        <el-input v-model="recInfo.applicantWxNumber" placeholder="申请人微信号" class="input-width" />
      </el-form-item>
      <el-form-item label="收款人:">
        <el-input v-model="recInfo.payee" placeholder="收款人" class="input-width" />
      </el-form-item>
      <el-form-item label="开户银行:">
        <el-input v-model="recInfo.bankName" placeholder="开户银行" class="input-width" />
      </el-form-item>
      <el-form-item label="卡号:">
        <el-input v-model="recInfo.bankCard" placeholder="卡号" maxlength="19" class="input-width" />
      </el-form-item>
      <el-form-item label="支行信息:">
        <el-input v-model="recInfo.branchInfo" placeholder="支行信息" class="input-width" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click.prevent="save">确定</el-button>
        <el-button type="warning" @click.prevent="back">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cases: {},
      recInfo: {
        recPhoneNumber: '',
        recMailbox: '',
        recWxNumber: '',
        applicantPhoneNumber: '',
        applicantMailbox: '',
        applicantWxNumber: '',
        payee: '',
        bankName: '',
        bankCard: '',
        branchInfo: '',
        infoVersion: '',
        caseCode: '',
        flowCode: ''
      }
    }
  },
  created() {
    this.$emit('setCurrentMenu', '变更受助人信息')
    this.getcaseInfo()
  },
  methods: {
    getcaseInfo() {
      const vm = this
      const caseCode = vm.$route.params.caseCode
      vm.cases.caseCode = caseCode
      vm.axios.get(vm.homePath() + '/case-info/information/' + caseCode)
        .then(res => {
          if (res.data.status == '000000') {
            vm.cases = res.data.data
            vm.recInfo.recPhoneNumber = vm.cases.recPhoneNumber
            vm.recInfo.recMailbox = vm.cases.recMailbox
            vm.recInfo.recWxNumber = vm.cases.recWxNumber
            vm.recInfo.applicantPhoneNumber = vm.cases.applicantPhoneNumber
            vm.recInfo.applicantMailbox = vm.cases.applicantMailbox
            vm.recInfo.applicantWxNumber = vm.cases.applicantWxNumber
            vm.recInfo.payee = vm.cases.payee
            vm.recInfo.bankName = vm.cases.bankName
            vm.recInfo.bankCard = vm.cases.bankCard
            vm.recInfo.branchInfo = vm.cases.branchInfo
            vm.recInfo.infoVersion = vm.cases.infoVersion
            vm.recInfo.caseCode = vm.cases.caseCode
            vm.recInfo.flowCode = vm.cases.flowCode
          } else {
            vm.$alert(res.data.message, '提示', {
              callback: () => {
                vm.$router.push('/index/caseDetailV2/' + vm.cases.caseCode)
              }
            })
          }
        })
        .catch(error => console.log(error))
    },

    save() {
      const past = true
      if (past) {
        const vm = this
        vm.axios.put(vm.homePath() + '/case-info/apply-info', vm.recInfo)
          .then(response => {
            if (response.data.status == '000000') {
              vm.$alert('操作成功', '提示', {
                callback: () => {
                  vm.$router.push('/index/caseDetailV2/' + vm.cases.caseCode)
                }
              })
            } else {
              vm.$alert(response.data.message, '提示')
            }
          })
          .catch(error => console.log(error))
      }
    },

    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
	.input-width {
		width:30%;
		min-width: 200px;
	}
</style>
